export default __webpack_public_path__ + "media/images/home/latest-project-creative-partnership.jpg";